module.exports = __webpack_public_path__ + "img/hidro01.e2a5afda.png";